/**
 * Will strip any HTML tags, but keep the text content from the original
 * string of HTML.
 *
 * @param html A string of HTML
 * @returns A stripped text from the HTML (without any HTML tags)
 */
export const stripHTML = (html: string): string => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText;
};
